<template>
    <div class="content v-box is-growy is-growx">
        <slot/>
    </div>
</template>


<script setup>
</script>

<style lang="scss">

@import '../assets/framework';

$content-color: $base-color;
$content-background: $white;
$content-shadow: 0 1.6px 3.6px 0 rgba(0,0,0,0.132), 0 0.3px 0.9px 0 rgba(0,0,0,0.108);
.content {
    margin: auto;
    padding: $base-padding;
    color: $content-color;
    background: $content-background;
    box-shadow: $content-shadow;
    overflow: auto;
}

</style>
